import React from 'react';

// Compact step indicator for multi-step Auth V2 flows (Register). Doubles as
// the "eyebrow" for the step's AuthHeader, so callers omit AuthHeader's own
// eyebrow when this is present, to avoid printing "ÉTAPE X SUR Y" twice.
export default function AuthProgress({ step, totalSteps, label }) {
  const percent = Math.round((step / totalSteps) * 100);
  return (
    <div className="auth-progress">
      <div className="auth-progress-row">
        <span className="auth-eyebrow">{label || `ÉTAPE ${step} SUR ${totalSteps}`}</span>
        <span className="auth-progress-percent">{percent}%</span>
      </div>
      <div
        className="auth-progress-track"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Étape ${step} sur ${totalSteps}`}
      >
        <div className="auth-progress-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
